import * as Actions from './actions'

const initialState = {
  accounts: [],
  user: {
    isSignedIn: false,
    uid: '',
    email: '',
  },
}

export const UsersReducer = (state = initialState.user, action) => {
  switch (action.type) {
    case Actions.SIGN_IN:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.SIGN_OUT:
      return {
        ...action.payload,
      }
    default:
      return state
  }
}

export const AccountsReducer = (state = initialState.accounts, action) => {
  switch (action.type) {
    case Actions.FETCH_ACCOUNTS:
      return {
        ...state,
        accounts: [...action.payload],
      }
    default:
      return state
  }
}
